import * as types from './mutation-types';
import { defaultState } from './state';
import * as _ from 'lodash';
const resetState_ = state => {
	Object.assign(state, _.cloneDeep(defaultState));
	// Object.assign(state, defaultState);
};
const resetYnState_ = state => {
	state.useYnList = [];
	state.gridUseYnList = [];
	// Object.assign(state, defaultState);
};
export default {
	resetYnState_,
	resetState_,
	[types.DEFAULT_ASSIGN]: (state, payload) => {
		state[payload.key] = payload.value;
	},
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	}
};
